import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { UpdateCheckRecipientRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { UpdateCheckRecipientResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const updateCheckRecipient = (request: UpdateCheckRecipientRequest, options?: CashRequestOptions) =>
  post<UpdateCheckRecipientRequest, UpdateCheckRecipientResponse>('/2.0/cash/update-check-recipient', request, {
    ...options,
    rejectOnError: true,
  })
